export const BD_CARE_SERVICE_AREA_SUFFIX_PLURALIZATION_MAPPING = {
  '=1': 'Versorgungsgebiet',
  'other': 'Versorgungsgebiete'
};
export interface CareServiceArea {
  "id" : number;
  "name" : string;
  "color" : string;
}
